<template>
  <div class="socioCustom">
    <div v-if="loading" class="loading-indicator">
      <LoadingIndicator />
    </div>
    <div v-else>
      <div class="carousel-container">
        <CarouselComponent :slides="allViews.sliders" />
        <div v-if="allViews.sliders.length > 0">
        </div>
      </div>
      <WelcomeComponent v-if="isAuthenticated" />
      <InformacionRelevante v-if="isAuthenticated" />
      <BlockComponent
        v-for="block in allViews.blocks"
        :key="block.id"
        :block="block"
      />
      <ServicesComponent v-if="allViews.cards.length > 0" :services="allViews.cards" />
      <ButtonLinkComponent v-if="allViews.buttonLinks.length > 0" :buttonLinks="allViews.buttonLinks" />

      <!-- <TelepaseComponent />-->
      <!-- <AcaComponent /> -->
      <NovedadComponent v-if="allViews.articles.length > 0" :articles="allViews.articles"/>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useImageLoader } from "@/composables/useImageLoader";
import { fetchViewByUrl } from "@/services/api/view.js";
import { useStore } from "vuex";

import NovedadComponent from "@/components/novedades/Novedad.vue";
import CarouselComponent from "@/components/carousel/CarouselComponent.vue";
import BlockComponent from "@/components/block/BlockComponent.vue";
import ButtonLinkComponent from "@/components/bottonLink/ButtonLinkComponent.vue";
import LoadingIndicator from "@/components/common/LoadingIndicator.vue";
import ServicesComponent from "@/components/servicios/Servicio.vue";
//import TelepaseComponent from "@/views/servicios/components/socios/TelepaseComponent.vue";
import WelcomeComponent from "@/views/servicios/components/socios/welcome/WelcomeComponent.vue";
import InformacionRelevante from "@/views/servicios/components/socios/InformacionRelevante.vue";
// import AcaComponent from "@/components/aca/AcaComponent.vue";

const { loading, allViews, loadImages } = useImageLoader();
const store = useStore();

const isAuthenticated = computed(() => !!store.state.user);

onMounted(() => {
  loadImages(fetchViewByUrl);
});
</script>

<style scoped>
.socioCustom {
  margin: 0 auto;
  position: relative;
}

.carousel-container {
  position: relative;
}
</style>
